import { useState, useRef, useEffect, useContext } from "react";

// context
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";

// components
import AppointmentTab from "./AppointmentTab";
import ClassTab from "./ClassTab";
import PlaceTab from "./PlaceTab";
import OptionTab from "./OptionTab";
import RequestAppPaymentPop from "./requestAppPayment";
import CustomAlertWithReasons from "bodycodi/cmap/app/components/common/alert2";

type PassListProp = {
  ClassPassList: Array<any>;
  AppointPassList: Array<any>;
  PlacePassList: Array<any>;
  OptionPassList: Array<any>;
  MemberDtlVO: any;
  PackageInfo: any;
  discountPermission: any;
  salePermission: any;
};

const PassListWrap = ({
  ClassPassList,
  AppointPassList,
  PlacePassList,
  OptionPassList,
  MemberDtlVO,
  PackageInfo,
  discountPermission,
  salePermission,
}: PassListProp) => {
  const { dispatch } = useContext(DispatchContext);
  const [tab, setTab] = useState(0);
  const [alert, setAlert] = useState<any>({
    open: false,
    header: "앱 결제 요청 안내",
    body: [],
  });
  const [active, setActive] = useState<any>({});
  const tabActive = useRef<HTMLDivElement>(null);

  useEffect(() => {
    tabActive.current!.style.transform = "translateX(0%)";
  }, []);

  const clickTab = (i: number) => () => {
    if (i === 0 && AppointPassList?.length === 0) return;
    if (i === 1 && ClassPassList?.length === 0) return;
    if (i === 2 && PlacePassList?.length === 0) return;
    if (i === 3 && OptionPassList?.length === 0) return;
    tabActive.current!.style.transform = "translateX(" + 100 * i + "%)";
    setTab(i);
  };

  const openPassConfirmPop = () => {
    const reasonList = [];

    if (active.saleYn === "N") reasonList.push("현재 판매 중지된 이용권이에요.");
    if (!salePermission) reasonList.push("이용권 판매 권한이 없어요.");
    if (!active.saleAvailable) reasonList.push("현재 판매 가능지점이 아니에요.");

    if (reasonList.length) {
      setAlert({
        ...alert,
        open: true,
        body: reasonList,
      });
    } else {
      dispatch({
        type: "POP_UP_OPEN",
        id: "REQUEST_APP_PAYMENT_POP",
        open: { requestAppPaymentPop: true },
      });
    }
  };

  return (
    <div className="member-wrap">
      <div className="member-title">보유한 이용권</div>
      <div className="member-pass-list-wrap">
        <div className={`member-pass-tab-wrap ${window?.innerWidth < 375 ? "width" : ""}`}>
          <div className={"member-pass-tab" + (tab === 0 ? " active" : "")} onClick={clickTab(0)}>
            개인 {AppointPassList?.length}
          </div>
          <div className={"member-pass-tab" + (tab === 1 ? " active" : "")} onClick={clickTab(1)}>
            그룹 {ClassPassList?.length}
          </div>
          <div className={"member-pass-tab" + (tab === 2 ? " active" : "")} onClick={clickTab(2)}>
            시설 {PlacePassList?.length}
          </div>
          <div className={"member-pass-tab" + (tab === 3 ? " active" : "")} onClick={clickTab(3)}>
            옵션 {OptionPassList?.length}
          </div>
          <div className="member-pass-tab-active" ref={tabActive}></div>
        </div>
        {tab === 0 && (
          <AppointmentTab
            AppointPassList={AppointPassList}
            active={active}
            setActive={setActive}
            MemberDtlVO={MemberDtlVO}
            openPassConfirmPop={openPassConfirmPop}
          />
        )}
        {tab === 1 && (
          <ClassTab
            ClassPassList={ClassPassList}
            setActive={setActive}
            openPassConfirmPop={openPassConfirmPop}
          />
        )}
        {tab === 2 && (
          <PlaceTab
            PlacePassList={PlacePassList}
            setActive={setActive}
            openPassConfirmPop={openPassConfirmPop}
          />
        )}
        {tab === 3 && (
          <OptionTab
            OptionPassList={OptionPassList}
            setActive={setActive}
            openPassConfirmPop={openPassConfirmPop}
          />
        )}
      </div>
      <RequestAppPaymentPop
        selectedPass={{
          ...active,
          userName: MemberDtlVO.name,
          userProfileImg: MemberDtlVO.imgUrl,
          discountPermission: discountPermission,
        }}
        packageInfo={PackageInfo.get(
          JSON.stringify({
            seqPackage: active?.seqPackage,
            seqPricing: active?.seqPricing,
          })
        )}
      />
      <CustomAlertWithReasons
        open={alert.open}
        setOpen={(open: any) => setAlert({ ...alert, open: open })}
        header={alert.header}
        body={alert.body}
        cancelAlert={() => {}}
        closeAlert={() => {}}
      />
    </div>
  );
};

export default PassListWrap;
